import {
    START_SESSION_REQUEST,
    START_SESSION_SUCCESS,
    START_SESSION_FAIL,
    START_SESSION_RESET,
    END_SESSION_REQUEST,
    END_SESSION_SUCCESS,
    END_SESSION_FAIL,
    END_SESSION_RESET,
    GET_ACTIVE_SESSION_REQUEST,
    GET_ACTIVE_SESSION_SUCCESS,
    GET_ACTIVE_SESSION_FAIL,
    GET_ACTIVE_SESSION_RESET,
    GET_SESSION_SUMMARY_REQUEST,
    GET_SESSION_SUMMARY_SUCCESS,
    GET_SESSION_SUMMARY_FAIL,
    GET_SESSION_SUMMARY_RESET,
} from '../constants/sessionConstants';

// ============================================================================
// START SESSION REDUCER
// ============================================================================
export const startSessionReducer = (state = {}, action) => {
    switch (action.type) {
        case START_SESSION_REQUEST:
            return { loading: true };
        case START_SESSION_SUCCESS:
            return { loading: false, success: true, session: action.payload };
        case START_SESSION_FAIL:
            return { loading: false, error: action.payload };
        case START_SESSION_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// END SESSION REDUCER
// ============================================================================
export const endSessionReducer = (state = {}, action) => {
    switch (action.type) {
        case END_SESSION_REQUEST:
            return { loading: true };
        case END_SESSION_SUCCESS:
            return { loading: false, success: true, session: action.payload };
        case END_SESSION_FAIL:
            return { loading: false, error: action.payload };
        case END_SESSION_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// ACTIVE SESSION REDUCER
// ============================================================================
export const activeSessionReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_ACTIVE_SESSION_REQUEST:
            return { loading: true };
        case GET_ACTIVE_SESSION_SUCCESS:
            return { loading: false, activeSession: action.payload };
        case GET_ACTIVE_SESSION_FAIL:
            return { loading: false, error: action.payload };
        case GET_ACTIVE_SESSION_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// SESSION SUMMARY REDUCER
// ============================================================================
export const sessionSummaryReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_SESSION_SUMMARY_REQUEST:
            return { loading: true };
        case GET_SESSION_SUMMARY_SUCCESS:
            return { loading: false, summary: action.payload };
        case GET_SESSION_SUMMARY_FAIL:
            return { loading: false, error: action.payload };
        case GET_SESSION_SUMMARY_RESET:
            return {};
        default:
            return state;
    }
};
